import { gql } from '@apollo/client';

const schema = {
  paymentStatus: {
    name: 'paymentStatus',
    serviceName: 'auth',
    query: gql`
      query paymentStatus($ids: [String]) {
        paymentStatus(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
  changePayment: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $payment_status_id: String) {
        updateOrder(ids: $ids, payment_status_id: $payment_status_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
